import { CountryAreaCode, countryAreaCodes } from './countryAreaCodes'

export const findPhoneNumberAreaCode = (country: string, combinedPhoneNumber: string): CountryAreaCode => {
  const defaultCountryCode = country
    ? countryAreaCodes.find(cpc => cpc.code.toLocaleLowerCase() === country.toLocaleLowerCase()) || countryAreaCodes[0]
    : countryAreaCodes[0]
  if (combinedPhoneNumber) {
    // if initial phone number contains a areacode, find the area code that is already present (fallback to shop country area code)
    // else if no area code is in the initial phone number already, set the area code to the default (shop country area code)
    if (combinedPhoneNumber.slice(0, 1) === '+') {
      const areaCode = countryAreaCodes.find(
        cpc => cpc.dialCode === combinedPhoneNumber.replace(/[^\d+]/g, '').slice(0, cpc.dialCode.length)
      )
      return areaCode || defaultCountryCode
    }
  }
  return defaultCountryCode
}

export const findCountryAreaCodeByDialCode = (country: string, number: string): CountryAreaCode => {
  if (number) {
    const startsWithPlusSign = number.slice(0, 1) === '+'
    // if the number is larger than the maximum amount of digits in a dialcode we slice
    const strippedValue = number.replace(/[^\d+]/g, '')
    const onlyDialcode = strippedValue.length > 5 ? strippedValue.slice(0, 5) : strippedValue
    if (startsWithPlusSign) {
      const areaCode = countryAreaCodes.find(cpc => onlyDialcode.startsWith(cpc.dialCode))
      if (areaCode) {
        return areaCode
      }
    }
  }
  return country
    ? countryAreaCodes.find(cpc => cpc.code.toLocaleLowerCase() === country.toLocaleLowerCase()) || countryAreaCodes[0]
    : countryAreaCodes[0]
}

// findDefaultAreaCode will return try to parse the area code from the value, otherwise the area code is looked up for that country
// returns: "+31"
export const findDefaultAreaCode = (country: string, value: string): CountryAreaCode => {
  if (value) {
    const startsWithPlusSign = value.slice(0, 1) === '+'
    const strippedValue = value.replace(/[^\d]/g, '')
    if (startsWithPlusSign) {
      const areaCode = countryAreaCodes.find(cpc => strippedValue.startsWith(cpc.dialCode))
      if (areaCode) {
        return areaCode
      }
    }
  }

  // Area code not found via phone number value
  return country
    ? countryAreaCodes.find(cpc => cpc.code.toLocaleLowerCase() === country.toLocaleLowerCase()) || countryAreaCodes[0]
    : countryAreaCodes[0]
}

export const cleanPhoneNumber = (phoneNumberToFormat: string, areaCode: CountryAreaCode, shopCountryCode: string): string => {
  // if the phonenumber and areacode are equal, then cleaned phonenumber is empty string
  if (phoneNumberToFormat === areaCode.dialCode) {
    return ''
  }

  // clean up the phone number, remove any - / . ( )
  let formattedNumber = phoneNumberToFormat ? phoneNumberToFormat.replace(/[^\d+]/g, '') : ''
  // remove the area code if it is included
  if (formattedNumber && formattedNumber.slice(0, 1) === '+' && formattedNumber !== '+') {
    if (areaCode.dialCode === formattedNumber.slice(0, areaCode.dialCode.length)) {
      formattedNumber = formattedNumber.slice(areaCode.dialCode.length)
    } else {
      const matchingAreaCode = findPhoneNumberAreaCode(shopCountryCode, formattedNumber || '')
      formattedNumber = formattedNumber.slice(matchingAreaCode.dialCode.length)
    }
  }
  return formattedNumber
}
